import CryptoJS from 'crypto-js';

export class GravityFormsApi {

  constructor(apiCreds) {
    const isValid = options => options.apiKey && options.domain && options.privateKey;

    if (isValid(apiCreds)) {
      this._setup(apiCreds);
    } else {
      this._throwError('Invalid api credentials');
    }
  }

  _setup(options) {
    const { apiKey, domain, privateKey } = options;

    this.apiKey = apiKey;
    this.privateKey = privateKey;
    this.baseEndPoint = `${domain}/gravityformsapi`;
  }

  _convertToFutureUnixTime(expirationInSeconds) {
    const currentDate = new Date();
    const unixTimeInSeconds = parseInt(currentDate.getTime() / 1000, 10);

    return unixTimeInSeconds + expirationInSeconds;
  }

  _throwError(desc) {
    throw new Error(desc);
  }

  createSignature(method, route, expirationInSeconds = 600) {
    if (!method || !route) {
      this._throwError('GravityFormsApi.createSignature is missing required arguments');
    }

    const futureUnixTime = this._convertToFutureUnixTime(expirationInSeconds);

    const stringToSign = `${this.apiKey}:${method}:${route}:${futureUnixTime}`;

    const hash = CryptoJS.HmacSHA1(stringToSign, this.privateKey);
    const base64 = hash.toString(CryptoJS.enc.Base64);

    return encodeURIComponent(base64);
  }

  createUri(route, method, expirationInSeconds){

    const futureUnixTime = this._convertToFutureUnixTime(expirationInSeconds);
    const signature = this.createSignature(method,route);

    return (
      `${this.baseEndPoint}/${route}/?api_key=${this.apiKey}&signature=${signature}` +
      `&expires=${futureUnixTime}`
    );
  }

  get(route, expirationInSeconds = 600) {

    if (!route) {
      this._throwError('GravityFormsApi.request is missing required arguments');
    }

    return fetch(this.createUri(route,'GET',expirationInSeconds));
  }

  submit(form_id, data, expirationInSeconds = 600){
    if (!data) {
      this._throwError('GravityFormsApi.request is missing required arguments');
    }

    const route = `forms/${form_id}/submissions`;

    return fetch(
      this.createUri(route,'POST',expirationInSeconds),
      {
        method: 'POST',
        body: JSON.stringify(data)
      }
    )
  }
}

export const createHtmlFromFieldData = field => {

};



// WEBPACK FOOTER //
// ./src/util/GravityFormsApi.js